import Sidebar from "../components/Sidebar";

function initials(label) {
  const words = String(label || "").trim().split(/\s+/).filter(Boolean);
  if (!words.length) return "?";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}

// One card per client from Management Finance's client list. The 8 with a
// dedicated calculation/workflow route straight there; the remaining 6 have
// no invoice-generation logic built yet, so they route to the generic
// Temporary/Other invoice with their name pre-filled — still one click to
// start an invoice, just without a client-specific formula behind it.
const workflows = [
  { label: "ARSL", description: "Allied Rental Services Limited — General Invoice Engine workbook", path: "/general-invoice?client=ARSL" },
  { label: "ATL", description: "Allied Transport Limited — General Invoice Engine workbook", path: "/general-invoice?client=ATL" },
  { label: "ATL CocaCola", description: "ATL CocaCola — Master Contractual workbook (any file name). Billed under ATL's name and NTN.", path: "/general-invoice?client=ATL_COCACOLA" },
  { label: "ES", description: "E-Commerce — General Invoice Engine workbook", path: "/general-invoice?client=ES" },
  { label: "CBRE", description: "CBRE Corporate Outsourcing — create invoices from the CBRE workbook", path: "/cbre-invoice" },
  { label: "IIL", description: "Attendance-linked IIL invoices and payroll", path: "/iil-invoice" },
  { label: "Corteva", description: "Corteva Agriscience Pakistan Limited — Seed DGs, CRC Staff, Agronomy, and no-upload segment templates", path: "/corteva-invoice?client=CORTEVA" },
  { label: "Corteva Crop", description: "Corteva Crop Pakistan (Private) Limited — IFS FO recurring workbook and the fixed-fee Consultant invoice", path: "/corteva-invoice?client=CORTEVA_CROP" },
  { label: "PTC AKF", description: "General Invoice Engine workbook — name the uploaded file with \"PTC\" or \"AKF\" in it so it's detected correctly", path: "/general-invoice?client=PTC_AKF" },
  { label: "AESL", description: "Allied Engineering — General Invoice Engine workbook", path: "/general-invoice?client=AESL" },
  { label: "Sefam Pvt Ltd", description: "Kayseria — General Invoice Engine workbook (name the file with \"Kayseria\" or \"KYS\" in it). Other departments not wired yet.", path: "/general-invoice?client=SEFAM" },
  { label: "GSolar Power", description: "Upload the shared G-Solar roster — filtered to GSolar Power (Pvt.) Ltd. by the DBA column automatically.", path: "/general-invoice?client=G_SOLAR" },
  { label: "VS Alpha", description: "Upload the shared G-Solar roster — filtered to VS Alpha Pakistan Pvt. Ltd by the DBA column automatically.", path: "/general-invoice?client=VS_ALPHA" },
  { label: "Nagina Electronics", description: "No dedicated workflow yet — create a manual invoice", path: "/temporary-invoice?client=TEMP&name=Nagina%20Electronics" },
  { label: "United Detergent", description: "Unit I — General Invoice Engine workbook. Upload the client's payroll sheet (detected automatically) plus a file named with \"Resource Cost\" in it.", path: "/general-invoice?client=UNITED_DETERGENT" },
  { label: "Temporary / Other", description: "Create a one-off manual invoice for any other client", path: "/temporary-invoice" }
];

function openWorkflow(path) {
  window.history.pushState({}, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
}

export default function CreateInvoiceHub() {
  return (
    <div className="app-shell">
      <Sidebar />
      <main className="main-content">
        <header className="page-header">
          <div>
            <div className="eyebrow">Invoice operations</div>
            <h1 className="page-title">Create Invoice</h1>
            <p className="page-copy">Pick a client to open its invoice workflow with all of its current calculations and controls.</p>
          </div>
        </header>
        <section className="workflow-card-grid">
          {workflows.map((workflow) => (
            <button
              key={`${workflow.label}-${workflow.path}`}
              type="button"
              className="workflow-card"
              onClick={() => openWorkflow(workflow.path)}
            >
              <div className="workflow-card-top">
                <span className="workflow-card-avatar">{initials(workflow.label)}</span>
                <span className="workflow-card-arrow">&rarr;</span>
              </div>
              <h3 className="workflow-card-title">{workflow.label}</h3>
              <p className="workflow-card-copy">{workflow.description}</p>
            </button>
          ))}
        </section>
      </main>
    </div>
  );
}
